function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5007 0.958496C8.31533 0.958496 5.75065 3.52318 5.75065 6.7085V7.66683C4.70313 7.66683 3.83398 8.53598 3.83398 9.5835V19.1668C3.83398 20.2143 4.70313 21.0835 5.75065 21.0835H17.2506C18.2982 21.0835 19.1673 20.2143 19.1673 19.1668V9.5835C19.1673 8.53598 18.2982 7.66683 17.2506 7.66683V6.7085C17.2506 3.52318 14.686 0.958496 11.5007 0.958496ZM11.5007 2.87516C13.682 2.87516 15.334 4.52715 15.334 6.7085V7.66683H7.66732V6.7085C7.66732 4.52715 9.3193 2.87516 11.5007 2.87516ZM5.75065 9.5835H17.2506V19.1668H5.75065V9.5835ZM11.5007 12.4585C10.4465 12.4585 9.58398 13.321 9.58398 14.3752C9.58398 15.4293 10.4465 16.2918 11.5007 16.2918C12.5548 16.2918 13.4173 15.4293 13.4173 14.3752C13.4173 13.321 12.5548 12.4585 11.5007 12.4585Z",
  fill: "#B4B8C3"
});

var SvgLockOutline = function SvgLockOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-outline.1b8e00a6.svg";
export { ForwardRef as ReactComponent };